module.exports = __webpack_public_path__ + "static/media/aglianico-sannio-dop-munifico-vinicola-del-sannio.83b80611.png";